// extracted by mini-css-extract-plugin
module.exports = {"disabledButton":"components_disabledButton__HH2M2","image":"components_image__PFbcf"};